import React, { FC } from 'react';

import { globalTheme } from '../../../../../../../shared/theme/theme';
import { YAxisTickProps } from '../../models/y-axis-props.model';

export const CustomYAxisTick: FC<YAxisTickProps> = ({
  x = 0,
  y = 0,
  payload,
}) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} textAnchor="end">
        <tspan dominantBaseline="middle" fontSize="large">
          {payload?.value}
        </tspan>
        <tspan
          fontSize={28}
          fill={globalTheme.palette.primary.main}
          dominantBaseline="middle"
        >
          ★
        </tspan>
      </text>
    </g>
  );
};
